import { useEffect } from "react";
import PropTypes from "prop-types";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

const PreselectClassification = ({
    baseUrl,
    Classification,
    updateRegistrationClassification,
    getIsClassificationAvailable,
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { classificationId } = useParams();
    const isClassificationAvailable =
        getIsClassificationAvailable(classificationId);

    useEffect(() => {
        if (isClassificationAvailable) {
            dispatch(
                updateRegistrationClassification({
                    Classification: [classificationId],
                }),
            );
        }
    }, []);
    useEffect(() => {
        if (
            Classification[0] === classificationId ||
            !isClassificationAvailable
        ) {
            navigate(`${baseUrl}/form/registration`);
        }
    }, [Classification]);
    return null;
};

PreselectClassification.propTypes = {
    baseUrl: PropTypes.string.isRequired,
    Classification: PropTypes.array,
    updateRegistrationClassification: PropTypes.func.isRequired,
};

export default PreselectClassification;
